import Card from "@/pages/Project/Detail/components/common/Card";
import TaskInfoIcon from "@/assets/images/BidDetail/ai-product-summary-icon.png";
import AssigneesIcon from "@/assets/images/BidDetail/ai-project-summary-icon.png";
import UserMessageIcon from "@/assets/images/BidDetail/business-restrict-icon.png";
import DetailCardItem from "@/components/DetailCardItem";
import CommonAvatar from "@/components/Common/Avatar";
import { useReadProjectGroupsOneTask } from "@/libs/react-query/hooks/useTaskQuery";
import TaskAssignees from "./TaskAssignees";
import TaskUserMessage from "./TaskUserMessage";
import { useNavigate, useParams } from "react-router-dom";
import TaskSelect from "@/pages/Project/Detail/columns/components/TaskSelect";
import { showToast } from "@/utils/toastUtils";
import { calculateDDay, cn, formatDate } from "@/libs/utils";
import useUserStore from "@/stores/User";

export default function TaskInfo() {
  const navigate = useNavigate();
  const currentUser = useUserStore((state) => state.user);

  const { task_id = "", group_id = "" } = useParams();
  const { data, isLoading, isError, error } = useReadProjectGroupsOneTask(
    group_id,
    task_id
  );

  if (isLoading) {
    return null;
  }

  if (isError) {
    showToast({
      type: "error",
      message:
        (error as any)?.response?.data?.display_message ||
        "에러가 발생했습니다.",
    });
    setTimeout(() => {
      navigate("/management/tasks");
    }, 0);
  }

  if (!data) {
    return null;
  }

  const {
    project_group_id,
    project_group_title,
    assignor,
    assignees,
    memos = [],
    status,
    due_date,
    created_at,
  } = data;

  const handleNavigateToProjectGroup = () => {
    navigate(`/management/projects/${project_group_id}`);
  };

  return (
    <div className="grid gap-5">
      <Card
        icon={TaskInfoIcon}
        title="작업 정보"
        className="min-h-fit flex flex-col gap-4"
      >
        <div className="flex gap-[44px] items-center">
          <div className="min-w-[68px] text-sm text-gray-B font-semibold">
            프로젝트명
          </div>
          <div className="text-sm text-gray-A font-normal">
            <button
              type="button"
              className="hover:underline"
              onClick={handleNavigateToProjectGroup}
            >
              {project_group_title}
            </button>
          </div>
        </div>
        <DetailCardItem
          label="요청자"
          value={
            <CommonAvatar
              img_url={assignor.img_url}
              name={assignor.user_name}
            />
          }
        />
        <DetailCardItem
          label="진행상태"
          value={
            <TaskSelect status={status} taskId={task_id} groupId={group_id} />
          }
        />
        <DetailCardItem label="요청일" value={formatDate(created_at)} />
        <DetailCardItem
          label="마감일"
          value={
            <span
              className={cn({
                "text-red font-bold":
                  calculateDDay(due_date) <= 3 && calculateDDay(due_date) >= 0, // D-3일 이하일 때 빨간색 강조
              })}
            >
              {formatDate(due_date)}
            </span>
          }
        />
      </Card>
      <div className="grid grid-cols-[240px_auto] gap-5">
        <Card icon={AssigneesIcon} title="작업자">
          <TaskAssignees assignees={assignees} />
        </Card>
        <Card icon={UserMessageIcon} title="작업 메모">
          <TaskUserMessage
            memos={memos}
            taskId={task_id}
            userId={currentUser?.user_id || ""}
            groupId={group_id}
          />
        </Card>
      </div>
    </div>
  );
}
